import React from 'react';

import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons';

import { Alert } from 'components/ui/alert';

interface Props extends Omit<React.ComponentPropsWithoutRef<typeof Alert>, 'title'> {
  errors?: string[] | null;
  error?: string | null; // Syntactic sugar for singular errors
  title?: boolean | string;
}

export const Errors = React.forwardRef<HTMLDivElement, Props>(function Errors(
  { error, errors, title = true, ...props },
  ref,
) {
  if (error) {
    errors = [error];
  }

  if (!errors?.length) {
    return null;
  }

  return (
    <Alert icon={faCircleExclamation} ref={ref} severity="destructive" {...props}>
      {title && <Alert.Title>{title === true ? 'Error' : title}</Alert.Title>}
      {errors?.map(error => (
        <div key={error}>{error}</div>
      ))}
    </Alert>
  );
});
